import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode } from '@shared/components/tree-view-check-box/tree-view-check-box.component';
import { OrganizationInterface } from '@shared/interfaces/organization.interface';

@Injectable({
  providedIn: 'root',
})
export class ReportingPopupService {
  constructor(
    protected readonly modalService: NgbModal,
    protected readonly translateService: TranslateService
  ) {}

  open(org: OrganizationInterface): void {
    const list = this.getCheckBoxItems(org);
    void this.openModal(list, org.id, org.showAsChallenge);
  }

  openAdminReport(): void {
    const list = this.getCheckBoxItemsForAdmin();
    void this.openModal(list);
  }

  async openModal(
    data = [],
    orgId = null,
    showAsChallenge = false
  ): Promise<void> {
    // The export dialog drags in the date pickers and forms: load it on demand.
    const { FormSummaryExportComponent } = await import(
      '@shared/components/form-summary-export/form-summary-export.component'
    );

    const modalRef = this.modalService.open(FormSummaryExportComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
      scrollable: false,
    });
    const component = modalRef.componentInstance as InstanceType<
      typeof FormSummaryExportComponent
    >;
    component.setOrgId(data, orgId, showAsChallenge);

    modalRef.result.catch(error => {
      console.log(error);
    });
  }

  getCheckBoxItems(org?: OrganizationInterface): TreeNode[] {
    let listCheckBox: TreeNode[] = [
      {
        text: this.translateService.instant('Ventures'),
        value: 'exportVentures',
        checked: true,
      },
      {
        text: this.translateService.instant('Events'),
        value: 'exportEvents',
        checked: true,
      },
      {
        text: this.translateService.instant('Organizations'),
        value: 'exportOrganizations',
        checked: true,
      },
      {
        text: this.translateService.instant('Calls & Challenges'),
        value: 'exportChallenges',
        checked: true,
      },
      {
        text: this.translateService.instant('People'),
        value: 'exportPeople',
        checked: true,
      },
    ];

    if (org?.showAsChallenge) {
      listCheckBox = listCheckBox.filter(
        item => item.value !== 'exportChallenges'
      );
    }

    return listCheckBox;
  }

  getCheckBoxItemsForAdmin(): TreeNode[] {
    return this.getCheckBoxItems().filter(
      item => item.value !== 'exportPeople'
    );
  }
}
